import { createStore, combineReducers } from "redux";
import user from "./reducer/user";
import layout from './reducer/layout'

let appReducer = combineReducers({
  user,
  layout
});
let store = createStore(
  appReducer
);

export default store;
